const state = {
    selectedPurchase: null, //stores the selected purchase(used in form modal)
    purchaseShow: false, //show=true | edit=false
    showPurchaseModal: false,//controls if the form modal is displayed or not

    invoices: [],
    paymentCondition: '',
};

const getters = {
    getSelectedPurchase(state){
        return state.selectedPurchase;
    },
    getPurchaseShow(state){
        return state.purchaseShow;
    },
    getShowPurchaseModal(state){
        return state.showPurchaseModal;
    },

    getPurchaseInvoice(state){
        return state.invoices;
    },
    getPurchasePaymentCondition(state){
        return state.paymentCondition;
    },

    getNewPurchase(state, getters, rootGetters) {
        return {
            code: '',
            clients_id: '',
            companies_id: '',
            company: rootGetters['Company/getNewCompany'],
            model_107_id: '',
            sell_date: '',
            delivery_date: '',
            deadline: '',
            transport: '',
            transport_cost: '',
            types_situation_id: '',
            types_sell_channel_id: '',
            types_document_type_id: '',
            types_operation_type_id: '',
            types_typology_id: '',
            series: '',
            fiscal_area_code: '',
            types_book_id: '',
            types_currency_id: '',
            users_made_id: '',
            users_registered_id: '',
            sell_tax: '',
        };
    }
};

const mutations = {
    setSelectedPurchase(state, payload){ //this also works for new article
        state.selectedPurchase = payload;
    },
    setPurchaseShow(state, payload){ //this also works for new article
        state.purchaseShow = payload;
    },
    setShowPurchaseModal(state, payload){
        state.showPurchaseModal = payload;
    },

    setPurchaseInvoices(state, payload){
        return state.invoices = payload;
    },
    setPurchasePaymentCondition(state, payload){
        return state.paymentCondition = payload;
    }
};

const actions = {
    setSelectedPurchase( {commit}, payload){
        commit('setSelectedPurchase', payload);
    },
    setPurchaseShow({commit}, payload){
        commit('setPurchaseShow', payload);
    },
    setShowPurchaseModal({commit}, payload){
        commit('setShowPurchaseModal', payload);
    },
    setPurchaseInvoices({commit}, payload){
        commit('setPurchaseInvoices', payload);
    },
    setPurchasePaymentCondition({commit}, payload){
        commit('setPurchasePaymentCondition', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};

